import { initAnimateProgressBar } from './animate_progress';

document.addEventListener('turbolinks:load', () => {
  if (document.body.classList.contains('learning-success')) {
    initAnimateProgressBar();
  }
});
